export const expandedDrawerWidth = 260;

export const routeRVIconScale = 150;
export const maxRouteMapZoom = 5;

// update timeline logic every 'routingTimelineUpdateInterval' ms (think of this like framerate)
export const routingTimelineUpdateInterval = 50;
// how much the timeline should move per update
export const wilmaTimelineMovementSpeed = 10000 * 60;
export const routingTimelineMovementSpeed = 10000 * 60;
